import { MediaQueryAllQueryable, MediaQueryMatchers, useMediaQuery } from 'react-responsive';

interface ResponsiveReturnValues {
  isMaxSm: boolean;
  isMaxMd: boolean;
  isMaxLg: boolean;
  isMaxXl: boolean;
  useMediaQuery: (
    settings: Partial<MediaQueryAllQueryable & { query?: string }>,
    device?: MediaQueryMatchers,
    callback?: (matches: boolean) => void,
  ) => boolean;
}

const getMedia = <T extends number>(breakpoint: T): `(max-width: ${T}px)` => `(max-width: ${breakpoint}px)`;

export const BREAKPOINTS = {
  sm: 767,
  md: 1023,
  lg: 1279,
  xl: 1535,
} as const;

export const MEDIA_QUERY = {
  sm: getMedia(BREAKPOINTS.sm),
  md: getMedia(BREAKPOINTS.md),
  lg: getMedia(BREAKPOINTS.lg),
  xl: getMedia(BREAKPOINTS.xl),
};

export const useResponsive = (): ResponsiveReturnValues => {
  const isMaxSm = useMediaQuery({ query: MEDIA_QUERY.sm });
  const isMaxMd = useMediaQuery({ query: MEDIA_QUERY.md });
  const isMaxLg = useMediaQuery({ query: MEDIA_QUERY.lg });
  const isMaxXl = useMediaQuery({ query: MEDIA_QUERY.xl });

  return {
    isMaxSm,
    isMaxMd,
    isMaxLg,
    isMaxXl,
    useMediaQuery,
  };
};
